const homeDataByLanguage = {
  en: {
    categoryCards: [
      {
        title: 'Manual Stackers',
        description: 'Compact, reliable machines built for daily warehouse handling.',
        href: '/machines/categories',
        tone: 'from-[#fff0e8] to-[#ffffff]',
        image: '/placeholders/1.webp',
      },
      {
        title: 'Electric Stackers',
        description: 'Power-assisted lifting for faster operations and reduced fatigue.',
        href: '/machines/categories',
        tone: 'from-[#ebf4ff] to-[#ffffff]',
        image: '/placeholders/1.webp',
      },
      {
        title: 'Spare Parts',
        description: 'Keep your equipment running with ready-to-install components.',
        href: '/spare-parts',
        tone: 'from-[#eefbf2] to-[#ffffff]',
        image: '/placeholders/1.webp',
      },
    ],
    heroSlides: [
      {
        description:
          'ETC offers a wide range of high-quality machines at exceptional prices including manual stackers, electric stackers, pallet trucks, and more.',
        primaryHref: '/machines/categories',
        primaryLabel: 'Discover our machines',
      },
    ],
    spotlightSlides: [
      {
        titleAccent: 'Explore Different',
        titleMain: 'Machines',
        description:
          'Discover a wide range of equipment and compare the options that fit your operation best.',
        ctaLabel: 'Explore Machines',
        ctaHref: '/machines/categories',
        image: '/slides/slide1.webp',
        mediaType: 'video',
        videoSrc: '/videos/1.mp4',
        videoPoster: '/slides/slide1.webp',
        chip: 'Machine Range',
        overlayClass: 'bg-none',
      },
      {
        titleAccent: 'Find The Right ',
        titleMain: 'Spare Part',
        description:
          'Check compatible spare parts for your machine and keep maintenance moving without delay.',
        ctaLabel: 'Check Spare Parts',
        ctaHref: '/spare-parts',
        image: '/slides/slide2.webp',
        chip: 'Machine Match',
        overlayClass: 'bg-none',
      },
      {
        titleAccent: 'Your Industrial',
        titleMain: 'Partner',
        description:
          'See how ETC supports your operations with equipment, service, and the right spare parts.',
        ctaLabel: 'Learn About ETC',
        ctaHref: '/about',
        image: '/slides/slide1.webp',
        chip: 'ETC Support',
        overlayClass: 'bg-none',
      },
    ],
    valuePoints: [
      {
        icon: 'gauge',
        title: 'Operational Performance',
        description: 'Equipment selected for uptime, consistency, and straightforward maintenance.',
      },
      {
        icon: 'shield',
        title: 'Field-Tested Reliability',
        description: 'Durable construction and practical safety features for demanding workflows.',
      },
      {
        icon: 'wrench',
        title: 'Service Continuity',
        description: 'A dedicated spare-part catalog to keep your fleet productive.',
      },
    ],
    homeServices: [
      {
        titleLine1: 'Quality',
        titleLine2: 'Machines',
        highlight: 'Quality',
        description:
          'We provide quality forklifts, pallet trucks, and many other machines at competitive prices.',
        image: '/services/1.webp',
      },
      {
        titleLine1: 'Spare Parts',
        titleLine2: 'Availability',
        highlight: 'Availability',
        description:
          'A dedicated stock of compatible spare parts to minimize downtime and keep your fleet operational.',
        image: '/services/2.webp',
      },
      {
        titleLine1: 'Preventive',
        titleLine2: 'Maintenance',
        highlight: 'Maintenance',
        description:
          'Planned inspections, wear-part replacement, and corrective interventions to reduce unplanned downtime.',
        image: '/services/3.webp',
      },
    ],
  },
  fr: {
    categoryCards: [
      {
        title: 'Gerbeurs manuels',
        description: 'Des machines compactes et fiables pour la manutention quotidienne.',
        href: '/machines/categories',
        tone: 'from-[#fff0e8] to-[#ffffff]',
        image: '/placeholders/1.webp',
      },
      {
        title: 'Gerbeurs électriques',
        description: 'Une assistance électrique pour accélérer les opérations et réduire la fatigue.',
        href: '/machines/categories',
        tone: 'from-[#ebf4ff] to-[#ffffff]',
        image: '/placeholders/1.webp',
      },
      {
        title: 'Pièces de rechange',
        description: 'Gardez vos équipements en service avec des composants prêts à installer.',
        href: '/spare-parts',
        tone: 'from-[#eefbf2] to-[#ffffff]',
        image: '/placeholders/1.webp',
      },
    ],
    heroSlides: [
      {
        description:
          'ETC vous propose une large gamme de machines de haute qualité à des prix exceptionnels : gerbeurs manuels, gerbeurs électriques, transpalettes et bien plus encore.',
        primaryHref: '/machines/categories',
        primaryLabel: 'Découvrez nos machines',
      },
    ],
    spotlightSlides: [
      {
        titleAccent: 'Explorer',
        titleMain: 'Différentes machines',
        description:
          'Découvrez une large gamme d’équipements et comparez les options adaptées à votre activité.',
        ctaLabel: 'Explorer les machines',
        ctaHref: '/machines/categories',
        image: '/slides/slide1.webp',
        mediaType: 'video',
        videoSrc: '/videos/1.mp4',
        videoPoster: '/slides/slide1.webp',
        chip: 'Gamme de machines',
        overlayClass: 'bg-none',
      },
      {
        titleAccent: 'Trouver',
        titleMain: 'La bonne pièce',
        description:
          'Vérifiez les pièces compatibles pour votre machine et gardez la maintenance en mouvement sans délai.',
        ctaLabel: 'Vérifier les pièces',
        ctaHref: '/spare-parts',
        image: '/slides/slide2.webp',
        chip: 'Compatibilité machine',
        overlayClass: 'bg-none',
      },
      {
        titleAccent: 'Votre partenaire industriel',
        titleMain: 'ETC',
        description:
          'Découvrez comment ETC soutient vos opérations avec des équipements, du service et les bonnes pièces de rechange.',
        ctaLabel: 'Découvrir ETC',
        ctaHref: '/about',
        image: '/slides/slide1.webp',
        chip: 'Support ETC',
        overlayClass: 'bg-none',
      },
    ],
    valuePoints: [
      {
        icon: 'gauge',
        title: 'Performance opérationnelle',
        description: 'Des équipements choisis pour la fiabilité, la constance et la maintenance simple.',
      },
      {
        icon: 'shield',
        title: 'Fiabilité testée sur le terrain',
        description: 'Une construction durable et des fonctions de sécurité adaptées aux usages intensifs.',
      },
      {
        icon: 'wrench',
        title: 'Continuité de service',
        description: 'Un catalogue de pièces dédié pour garder votre flotte productive.',
      },
    ],
    homeServices: [
      {
        titleLine1: 'Machines de',
        titleLine2: 'qualité',
        highlight: 'qualité',
        description:
          'Nous fournissons à tous nos clients des chariots élévateurs de qualité, des transpalettes et de nombreuses autres machines au meilleur prix.',
        image: 'services/1.webp',
      },
      {
        titleLine1: 'Disponibilité des',
        titleLine2: 'pièces',
        highlight: 'pièces',
        description:
          'Un stock dédié de pièces de rechange compatibles pour réduire les arrêts et maintenir votre flotte opérationnelle.',
        image: 'services/2.webp',
      },
      {
        titleLine1: 'Maintenance',
        titleLine2: 'préventive',
        highlight: 'préventive',
        description:
          'Inspections planifiées, remplacement des pièces d usure et interventions correctives pour limiter les arrêts imprévus.',
        image: 'services/3.webp',
      },
    ],
  },
};

export function getHomeData(language = 'en') {
  return homeDataByLanguage[language] || homeDataByLanguage.en;
}
